const { default: axiosIns } = require('@/libs/axios')

const PlacementsService = {
  // GET - PlacementApiController
  async getPlacement(propertyId, placementId, accountId) {
    return axiosIns.get(`/properties/${propertyId}/placements/${placementId}?accountId=${accountId}`).then(response => response.data)
  },
  // POST - PlacementApiController
  async createPlacement(propertyId, model, accountId) {
    return axiosIns.post(`/properties/${propertyId}/placements?accountId=${accountId}`, model).then(resopnse => resopnse.data)
  },
}

export default PlacementsService
